import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PromotionsService } from '../../promotions.service';
import {Location} from '@angular/common'; 
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';


@Component({
  selector: 'app-edit-videos',
  templateUrl: './edit-videos.component.html',
  styleUrls: ['./edit-videos.component.scss']
})
export class EditVideosComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  bannerPromoForm :FormGroup;
  countries: Array<any>;
  previousUrl: string;
  festivalId: any;
  festivalDetails: any;
  bannerPromoDetails:any;
  selectedcountry: any;
  today = new Date();

  constructor(private activeRoute: ActivatedRoute,private _location: Location, private fb: FormBuilder, private router: Router, public dialog: MatDialog, private promotionsService: PromotionsService, private toastr:ToastrService) {
    super();
    this.festivalId =this.activeRoute.snapshot.params.id;
  }

  private initForm() {
    this.bannerPromoForm = new FormGroup({
      headerName: new FormControl('', [Validators.required]),
      videoUrl: new FormControl('', [Validators.required, this.youtubeUrlValidator]),
      status: new FormControl('Active',[Validators.required]),
      language: new FormControl('English',[Validators.required]),
      promotionCreatdttm:new FormControl('',[Validators.required]),
    })
  }
  youtubeUrlValidator(control: FormControl) {
    const url = control.value;
    if (url && !url.startsWith("https://youtu.be/")) {
      return { invalidUrl: true };
    }
    return null; // Return null if the URL is valid
  }
  get f() {
    return this.bannerPromoForm.controls;
  }


  ngOnInit(): void {
    super.ngOnInit()
    this.bannerPromoForm = new FormGroup({
      headerName: new FormControl('', [Validators.required]),
      videoUrl: new FormControl('', [Validators.required, this.youtubeUrlValidator]),
      status: new FormControl('Active',[Validators.required]),
      language: new FormControl('English',[Validators.required]),
      promotionCreatdttm:new FormControl('',[Validators.required]),
    })
    if (this.festivalId && this.festivalId) {
     
      this.promotionsService.getVideo(this.festivalId).subscribe(
        res => {
          let data: any = res;
          this.bannerPromoDetails = data.data;
          this.bannerPromoForm.get('headerName').setValue(this.bannerPromoDetails.headerName),
          this.bannerPromoForm.get('videoUrl').setValue(this.bannerPromoDetails.videoUrl),
          this.bannerPromoForm.get('status').setValue(this.bannerPromoDetails.status),
          this.bannerPromoForm.get('language').setValue(this.bannerPromoDetails.language),
          this.bannerPromoForm.get('promotionCreatdttm').setValue(moment(this.bannerPromoDetails.promotionCreatdttm).format())
  })
    }
  }
  onCancel() { 
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigate(['features/promotions/video-config']);
      }
    });    
  }
  onSubmit() {
   
    if (this.bannerPromoForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.bannerPromoForm)
        }else{
          this.router.navigate(['features/promotions/video-config']);
        }
      });

    }
  }
  setSubmitParameters(bannerPromoForm: FormGroup) {

    let httpParams: Params = {
      instructionsId :Number(this.festivalId),
      headerName : bannerPromoForm.get('headerName').value,
      videoUrl: bannerPromoForm.get('videoUrl').value,
      status: bannerPromoForm.get('status').value,
      language: bannerPromoForm.get('language').value,
      promotionCreatdttm: moment(bannerPromoForm.get('promotionCreatdttm').value).format('MM-DD-YYYY'),
    }
    console.log(httpParams);
    this.promotionsService.updateVideos(httpParams).subscribe(res => {
      if (res && res) { //alert("h3"); 
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.router.navigate(['features/promotions/video-config'])
          this.toastr.success('Video Info updated successfully', 'Success', {
            timeOut: 3000,
          });        
        }
      }
    });
  }
  checkSubmitDisplayed() {
    return !(this.bannerPromoForm.valid && !this.bannerPromoForm.pristine); 
  }
  
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}